module.exports = __webpack_public_path__ + "static/media/plastificirani-kanati.474f6b5b.png";